import { Fragment } from "react";
import { ImageIcon } from "lucide-react";
import { api } from "../lib/api";

export const aideImageUrl = (id) => (id.startsWith("/") ? id : `${api.defaults.baseURL}/aide/images/${id}`);

const Inline = ({ text }) =>
  text.split(/(\*\*[^*]+\*\*|https?:\/\/\S+)/g).map((p, i) => {
    if (p.startsWith("**") && p.endsWith("**")) return <strong key={i} className="font-semibold text-chalk">{p.slice(2, -2)}</strong>;
    if (/^https?:\/\//.test(p)) return <span key={i} className="break-all text-sky-300 underline">{p}</span>;
    return <Fragment key={i}>{p}</Fragment>;
  });

export const AideBloc = ({ b, i, editor = false }) => {
  const tid = `aide-bloc-${i}`;
  if (b.type === "titre") return <h2 data-testid={tid} className="mt-12 border-l-4 border-lime pl-3 font-display text-2xl uppercase leading-tight text-lime sm:text-3xl">{b.texte}</h2>;
  if (b.type === "soustitre") return <h3 data-testid={tid} className="mt-8 font-display text-xl uppercase text-chalk">{b.texte}</h3>;
  if (b.type === "encadre") return <div data-testid={tid} className="mt-4 whitespace-pre-wrap rounded-2xl border border-lime/50 bg-lime/10 px-4 py-3 text-sm leading-relaxed text-chalk sm:text-base"><Inline text={b.texte} /></div>;
  if (b.type === "image") {
    if (!b.image) {
      return editor ? <div data-testid={tid} className="mt-4 flex items-center gap-2 rounded-2xl border border-dashed border-line px-4 py-6 text-sm text-dim"><ImageIcon className="h-5 w-5" />Image à ajouter{b.nom ? ` (${b.nom})` : ""}</div> : null;
    }
    return (
      <figure data-testid={tid} className="mt-5">
        <img src={aideImageUrl(b.image)} alt={b.texte || b.nom || "Capture d'écran"} loading="lazy" className="mx-auto w-full max-w-xl rounded-2xl border border-line shadow-lg" />
        {b.texte && <figcaption className="mt-2 text-center text-xs text-dim">{b.texte}</figcaption>}
      </figure>
    );
  }
  return <p data-testid={tid} className="mt-4 whitespace-pre-wrap text-sm leading-relaxed text-chalk/90 sm:text-base"><Inline text={b.texte} /></p>;
};
